let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("79K0y")).then(() => parcelRequire('lPJba'));